"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatMultiLineHtmlText = exports.kebabToCamel = exports.camelToKebab = exports.capitalizeFirstLetter = exports.simpleHash = void 0;
const tslib_1 = require("tslib");
const sanitize_html_1 = tslib_1.__importDefault(require("sanitize-html"));
/**
 * Returns a hash code from a string
 * @param str The string to hash.
 * @return A 32bit integer converted to string
 */
function simpleHash(str) {
    let hash = 0;
    for (let i = 0, len = str.length; i < len; i++) {
        let chr = str.charCodeAt(i);
        hash = (hash << 5) - hash + chr;
        hash = hash | 0; // Convert to 32bit integer
    }
    return String(hash);
}
exports.simpleHash = simpleHash;
function capitalizeFirstLetter(string) {
    return string ? string[0].toUpperCase() + string.slice(1) : '';
}
exports.capitalizeFirstLetter = capitalizeFirstLetter;
function camelToKebab(str) {
    return str.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
}
exports.camelToKebab = camelToKebab;
function kebabToCamel(str) {
    return str.replace(/-([a-z])/g, (_, letter) => letter.toUpperCase());
}
exports.kebabToCamel = kebabToCamel;
function formatMultiLineHtmlText(text) {
    if (!text)
        return text;
    const sanitizedText = (0, sanitize_html_1.default)(text, { allowedTags: ['b'] });
    return sanitizedText
        .replace(/(\s*(?:\n\r?|\r\n?)\s*){2,}/g, `<div class="u-half-break"></div>`)
        .replace(/(?:\n\r?|\r\n?)/g, '<br>');
}
exports.formatMultiLineHtmlText = formatMultiLineHtmlText;
//# sourceMappingURL=index.js.map